// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-editor__editable .ck-horizontal-line{\n  display:flow-root\n}\n\n.ck-content hr{\n  height:4px\n}\n\n[dir] .ck-content hr{\n  margin:15px 0;\n  background:#dedede;\n  border:0\n}", ""]);
// Exports
module.exports = exports;
